export const firebaseConfig = {
    apiKey: "AIzaSyC0clC9QZEqnyPAanI7fsH4Sv9xvuM9Sss",
    authDomain: "creative-agency-88651.firebaseapp.com",
    projectId: "creative-agency-88651",
    storageBucket: "creative-agency-88651.appspot.com",
    messagingSenderId: "899778278897",
    appId: "1:899778278897:web:147728ce2ff271c63b8050"
  };